<template>
  <div class="survey-base-info">
    <div class="tips">
      <span>完善信息，推荐更适合孩子的课程</span>
    </div>
    <div class="header">孩子的性别</div>
    <div class="sex-block">
      <div class="sex-item"
           :class="{ 'active': sex === item.key}"
           v-for="(item, index) in sexList"
           :key="index"
           @click="handleSelectSex(item.key, item.value)"
      >
        <span>{{ item.value }}</span>
        <ym-icon class="male ym-icon"
                  :name="item.value === '男生' ?'male' : 'female'"
        />
      </div>
    </div>
    <div class="datetime-picker">
      <div class="title">
        <span>孩子的生日</span>
      </div>
      <datetime-picker type="date"
                       format="YYYY年MM月MM日"
                       v-model="value"
                       :show-toolbar="false"
                       :formatter="formatter"
                       :visible-item-count="3"
                       :min-date="birthdayStartDate"
                       :max-date="birthdayEndDate"
                       @change="onChange"
      />
    </div>
    <div class="submit-btn ym-mw-component-fixed-max">
      <ym-button type="primary"
                 size="large"
                 round
                 :disabled="submitDisabled"
                 v-ym-report:LEARNING_INFO_STEP_1_CONFIRM_CLICK=""
                 @click="handleSubmit"
      >
        确定
      </ym-button>
    </div>
  </div>
</template>

<script>
  import { Button, DatetimePicker } from '@ymba/ym-ui';

  export default {
    name: 'SurveyBaseInfo',
    components: {
      'ym-button': Button,
      DatetimePicker,
    },
    props: {
      sexList: {
        type: Array,
      },
      ageList: {
        type: Array,
      },
      params: {
        type: Object,
      },
    },
    data() {
      return {
        sex: this.params.sex,
        sexValue: this.params.sexValue,
        age: this.params.age,
        ageValue: this.params.ageValue,
        birthday: this.params.birthday,
        changeType: this.params.changeType,
        birthdayStartDate: new Date(`${new Date().getFullYear() - 25}-01-01`),
        birthdayEndDate: new Date(),
        currentDate: this.params.currentDate,
        value: this.params.currentDate,
      };
    },
    computed: {
      submitDisabled() {
        return this.sex === '';
      },
    },
    methods: {
      formatter(type, value) {
        if (type === 'year') return `${value}年`;
        if (type === 'month') return `${value}月`;
        if (type === 'day') return `${value}日`;
        return `${value}`;
      },

      initDate(dateTime) {
        return [dateTime.getFullYear(), dateTime.getMonth() + 1, dateTime.getDate()].join('-');
      },

      // 计算当前选择的年月日,组合形式为xx-xx-xx
      formatDate(dateValue) {
        const year = dateValue[0].substring(0, 4);
        const month = dateValue[1].substring(0, 2);
        const day = dateValue[2].substring(0, 2);
        this.currentDate = new Date(year, month - 1, day);
        this.getAge([year, month, day]);
        return [year, month, day].join('-');
      },

      // 获取当前年龄
      getAge(birthday) {
        const birthYear = Number(birthday[0]);
        const birthMonth = Number(birthday[1]);
        const birthDaY = Number(birthday[2]);

        const date = new Date();
        const nowYear = date.getFullYear();
        const nowMonth = date.getMonth() + 1;
        const nowDay = date.getDate();

        if (nowYear === birthYear) {
          this.ageValue = this.calcMonthAge(nowMonth, birthMonth, nowDay, birthDaY);
        } else {
          const ageDiff = nowYear - birthYear;
          this.ageValue = this.calcYearAge(ageDiff, nowMonth, birthMonth, nowDay, birthDaY);
        }
      },
      // 计算小于一岁年龄
      calcMonthAge(nowMonth, birthMonth, nowDay, birthDaY) {
        if (nowMonth > birthMonth) {
          if (nowDay >= birthDaY) {
            return `${ nowMonth - birthMonth }个月`;
          }
          return `${ nowMonth - birthMonth - 1 }个月`;
        }
        return '0个月';
      },
      // 计算等于一岁年龄
      calcOneYearAge(ageDiff, nowMonth, birthMonth, nowDay, birthDaY) {
        if (nowMonth === birthMonth) {
          if (nowDay >= birthDaY) return `${ ageDiff }岁`;
          return '11个月';
        }
        if (nowMonth > birthMonth) {
          return `${ ageDiff }岁`;
        }
        if (nowDay >= birthDaY) {
          return `${ 12 - birthMonth + nowMonth }个月`;
        }
        return `${ 11 - birthMonth + nowMonth }个月`;
      },
      // 计算大于一岁年龄
      calcYearAge(ageDiff, nowMonth, birthMonth, nowDay, birthDaY) {
        if (ageDiff === 1) {
          return this.calcOneYearAge(ageDiff, nowMonth, birthMonth, nowDay, birthDaY);
        }
        if (nowMonth === birthMonth) {
          if (nowDay >= birthDaY) return `${ ageDiff }岁`;
          return `${ ageDiff - 1 }岁`;
        }
        if (nowMonth > birthMonth) {
          return `${ ageDiff }岁`;
        }
        return `${ ageDiff - 1 }岁`;
      },

      onChange(picker) {
        this.birthday = this.formatDate(picker.getValues());
        this.changeType = true;
      },

      handleSelectSex(sex, sexValue) {
        this.sex = sex;
        this.sexValue = sexValue;
      },
      handleSubmit() {
        const params = {
          age: this.ageValue,
          ageValue: this.ageValue,
          sex: this.sex,
          birthday: this.birthday,
          sexValue: this.sexValue,
          currentDate: this.currentDate,
          changeType: this.changeType,
        };
        if (!this.changeType) {
          params.birthday = this.initDate(new Date());
          params.ageValue = '0个月';
          params.age = '0个月';
          this.$dialog.confirm({
            title: '提示',
            message: '请确认孩子的出生日期为今天？',
            confirmButtonText: '确认',
            cancelButtonText: '重新选择',
            closeOnClickOverlay: false,
          }).then(() => {
            this.$emit('baseInfo', params);
          }).catch();
          return;
        }
        this.$emit('baseInfo', params);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .survey-base-info {
    padding: @size-large @size-medium @size-medium @size-medium;
    box-sizing: border-box;
  }

  .header {
    margin-bottom: @size-small * 2 - 10;
    color: @color-text-base;
    text-align: center;
    font-size: @font-size-extra-large;
    font-weight: @font-weight-bold;
  }

  .sex-block {
    padding: 0 @size-large;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .sex-item {
    width: 250px;
    height: 250px;
    padding: @size-base 0 @size-medium 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: @border-radius-medium;
    border: @border-width-base @border-style-base @color-gray-light;
    font-size: @font-size-large;
    color: @color-text-light;
    line-height: 1;
    .ym-icon {
      margin-top: 44px;
      font-size: @font-size-largest * 2;
      color: @color-gray-light;
    }
    &.active {
      color: @color-text-base;
      border: @border-width-base @border-style-base @color-primary-aide;
      background: @color-primary-lighter;
      .ym-icon {
        color: @color-primary-aide;
      }
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 0;
    padding: @size-medium;
  }

  .tips {
    text-align: center;
    font-size: @font-size-base;
    color: @color-primary-aide;
    margin-bottom: @size-extra-medium;
    span {
      display: inline-block;
      padding: 8px 40px;
      background: @color-primary-lighter;
      border-radius: @size-base;
    }
  }

  .datetime-picker {
    margin-top: @size-extra-medium;
  }

  .title {
    font-size: @font-size-extra-large;
    font-weight: @font-weight-bold;
    color: @color-text-base;
    text-align: center;
    margin-bottom: @size-medium;
  }
</style>
